import Spinner from './SpinnerOverlay';
import styled from './styled';

const LoadingOverlay = styled(Spinner).attrs(() => ({
  color: '#222',
  textStyle: {
    fontWeight: '300',
    color: '#222',
    fontSize: 14,
  },
  overlayColor: 'rgba(255, 255, 255, 0.50)',
}))``;

export default LoadingOverlay;
